var map = {
	"./mambo.mp3": 4153,
	"./swing.mp3": 4154,
	"./tango.mp3": 4155
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 712;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/dances .\.mp3*
// module id = 712
// module chunks = 0